import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {Options} from 'ng5-slider';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {
  @Input() value: number = 3;
  @Output() onChangeValue: EventEmitter<void> = new EventEmitter();

  options: Options = {
    floor: 1,
    ceil: 3,
    showTicks: true,
    getLegend: (value: number): string => {
      if (value == 1)
        return '<b>S</b>';
      if (value == 2)
        return '<b>M</b>';
      if (value == 3)
        return '<b>L</b>';
    }
  };
  constructor() { }

  ngOnInit(): void {
  }

  onChange(event): void {
    this.onChangeValue.emit(event);
  }
}
